
import { defineComponent, ref } from "vue";
import { RouterName } from "@/models/common";
import MainNavigation from "./MainNavigation.vue";
import router from "@/router";
import AuthNavigation from "@/components/common/AuthNavigation.vue";
import { useI18n } from "vue-i18n";
import useCompany from "@/services/serviceProvider";

export default defineComponent({
  name: "Header",
  setup() {
    const rootPath = ref(process.env.BASE_URL);
    const { name } = router.currentRoute.value.meta;
    const hamburger = ref(false);
    const { t } = useI18n();
    const company = useCompany();

    /**
     * mobile menu click event
     */
    const toggleHamburger = (bool: Boolean = !hamburger.value) => {
      hamburger.value = bool.valueOf();
    };

    const goBack = () => {
      router.back();
    };

    return { RouterName, rootPath, name, hamburger, toggleHamburger, goBack, t, company };
  },
  components: { MainNavigation, AuthNavigation },
});
